import ViewBase from "../framework/core/mvvm/view_base";

const {ccclass, property, executeInEditMode, menu} = cc._decorator;

//详细用法参考：https://docs.cocos.com/creator/manual/zh/scripting/tween.html?h=%E7%BC%93%E5%8A%A8

@ccclass('TweenData')
class TweenData {
    @property(cc.String)
    name: String = "";

    @property(cc.Node)
    target: cc.Node = null;

    @property(cc.Vec2)
    startPos: cc.Vec2 = null;
    @property(cc.Vec2)
    endPos: cc.Vec2 = null;

    @property(cc.Integer)
    startOpacity  = 255
    @property(cc.Integer)
    endOpacity = 255

    @property(cc.Float)
    duration = 0.5

    @property(cc.Float)
    delay = 0

    @property(cc.Boolean)
    finishIncctive = false

    lastTween

    targetOriginPosition : cc.Vec2

    targetWidget : cc.Widget
}

@ccclass
@menu('UI/UTween')
@executeInEditMode
export default class UTween extends cc.Component {
    private _init : boolean

    @property(ViewBase)
    viewBase: ViewBase = null;

    @property(TweenData)
    tweenDatas: TweenData[] = [];

    onLoad() {
        if (!this._init) {
            this._init = true
            // this.targetComponent = this.getComponent<cc.Button>(cc.Button)
            if (this.viewBase) {
                this.viewBase.cacheTweenDatas(this)
            }
            this._cacheTargetPosition()
        }
    }

    _cacheTargetPosition() {
        this.tweenDatas.forEach(element => {
            if (element.target) {
                element.targetWidget = element.target.getComponent(cc.Widget)
                element.targetOriginPosition = element.target.position
            }
        })
    }

    //name 指定播放某些名字的tween, inverted 是否倒序播放
    to(name ?: string, inverted ?: boolean, callback ?) {
        //cc.log("UTween", this.node.name, name)
        let callTweenCount = 0
        this.tweenDatas.forEach(element => {
            if (element.name != "" && name && element.name.indexOf(name) < 0) {
                return
            }
            if (element.target == null) {
                return
            }
            let data : any = null
            // let widget : cc.Widget = null
            if (element.startOpacity != element.endOpacity) {
                data = {}
                if (inverted) {
                    element.target.opacity = element.endOpacity
                    data.opacity = element.startOpacity
                } else {
                    element.target.opacity = element.startOpacity
                    data.opacity = element.endOpacity
                }
            }


            if (element.startPos != null && element.startPos != element.endPos) {
                data = data ? data : {}
                // widget = element.target.getComponent(cc.Widget)
                //当前的地址
                let offsetPositonX = 0
                let offsetPositonY = 0
                if (element.targetWidget != null) {
                    element.targetWidget.updateAlignment()
                    offsetPositonX = element.target.position.x - element.targetOriginPosition.x
                    offsetPositonY = element.target.position.y - element.targetOriginPosition.y
                }

                //需要考虑到适配的问题，因为所有填的值都是以基准分辨率1920*1080
                if (inverted) {
                    element.target.position = new cc.Vec2(element.endPos.x + offsetPositonX, element.endPos.y + offsetPositonY)
                    data.position = new cc.Vec2(element.startPos.x + offsetPositonX, element.startPos.y + offsetPositonY)
                } else {
                    element.target.position = new cc.Vec2(element.startPos.x + offsetPositonX, element.startPos.y + offsetPositonY)
                    // data.position = element.endPos
                    data.position = new cc.Vec2(element.endPos.x + offsetPositonX, element.endPos.y + offsetPositonY)
                }
            }
            if (data != null) {
                if (element.lastTween != null) {
                    element.lastTween.stop()
                }
                element.target.active = true
               
                let tween = null;
                if (element.delay) {
                    //@ts-ignore
                    tween = cc.tween(element.target).delay(element.delay).to(element.duration, data)
                }else{
                    //@ts-ignore
                    tween = cc.tween(element.target).to(element.duration, data)
                }
                
                if (element.targetWidget != null) {
                    element.targetWidget.enabled = false
                    tween.call(() => {
                        if (element.targetWidget != null) {  //这里有点问题
                            element.targetWidget.enabled = true
                        }
                        element.lastTween = null
                        if (element.finishIncctive) {
                            element.target.active = false
                        }
                        --callTweenCount
                        if (callTweenCount <= 0 && callback) {
                            callback()
                            //TimeManager.instance.scheduleOnce(callback(),10);
                            //this.scheduleOnce(callback(),100);
                        }
                    })
                }
                tween.start()
                ++callTweenCount
                element.lastTween = tween
            }
        });

    }


    //name 指定播放某些名字的tween, inverted 是否倒序播放
    toPoint(name ?: string, inverted ?: boolean, callback ?) {
        //cc.log("UTween", this.node.name, name)
        let callTweenCount = 0
        this.tweenDatas.forEach(element => {
            if (name != element.name) {
                return
            }
            let data : any = null
            // let widget : cc.Widget = null
            if (element.startOpacity != element.endOpacity) {
                data = {}
                if (inverted) {
                    element.target.opacity = element.endOpacity
                    data.opacity = element.startOpacity
                } else {
                    element.target.opacity = element.startOpacity
                    data.opacity = element.endOpacity
                }
            }


            if (element.startPos != null && element.startPos != element.endPos) {
                data = data ? data : {}
                // widget = element.target.getComponent(cc.Widget)
                //当前的地址
                let offsetPositonX = 0
                let offsetPositonY = 0
                if (element.targetWidget != null) {
                    element.targetWidget.updateAlignment()
                    offsetPositonX = element.target.position.x - element.targetOriginPosition.x
                    offsetPositonY = element.target.position.y - element.targetOriginPosition.y
                }

                //需要考虑到适配的问题，因为所有填的值都是以基准分辨率1920*1080
                if (inverted) {
                    element.target.position = new cc.Vec2(element.endPos.x + offsetPositonX, element.endPos.y + offsetPositonY)
                    data.position = new cc.Vec2(element.startPos.x + offsetPositonX, element.startPos.y + offsetPositonY)
                } else {
                    element.target.position = new cc.Vec2(element.startPos.x + offsetPositonX, element.startPos.y + offsetPositonY)
                    // data.position = element.endPos
                    data.position = new cc.Vec2(element.endPos.x + offsetPositonX, element.endPos.y + offsetPositonY)
                }
            }
            if (data != null) {
                if (element.lastTween != null) {
                    element.lastTween.stop()
                }
                element.target.active = true
                //@ts-ignore
                let tween = cc.tween(element.target).delay(element.delay).to(element.duration, data)
                if (element.targetWidget != null) {
                    element.targetWidget.enabled = false
                    tween.call(() => {
                        if (element.targetWidget != null) {  //这里有点问题
                            element.targetWidget.enabled = true
                        }
                        element.lastTween = null
                        if (element.finishIncctive) {
                            element.target.active = false
                        }
                        --callTweenCount
                        if (callTweenCount <= 0 && callback) {
                            callback()
                            //TimeManager.instance.scheduleOnce(callback(),10);
                            //this.scheduleOnce(callback(),100);
                        }
                    })
                }
                tween.start()
                ++callTweenCount
                element.lastTween = tween
            }
        });

    }

    protected resetInEditor() {
        if (this.viewBase == null) {
            let parent = this.node
            while (parent != null) {
                this.viewBase = parent.getComponent<ViewBase>(ViewBase)
                if (this.viewBase != null) {
                    break;
                }
                parent = parent.parent
            }
        }
    }

}
